import dayjs from 'dayjs';
import { TOrganizationContractForm } from '../schema';
import { getDateOnlyISOFormat } from '@/utils/convertDate';

/**
 * The index of the contract running today, the one the API holds to the seats
 * already taken; the last contract when none covers today. Contract days are
 * UTC days, as the API counts them.
 * @param contracts - The organization's contracts.
 * @param now - The moment to judge by; the current time when omitted.
 * @returns The index of the contract running today, or of the last one.
 */
export const getActiveContractIndex = (
  contracts: TOrganizationContractForm[],
  now: dayjs.ConfigType = dayjs(),
) => {
  const today = getDateOnlyISOFormat(dayjs(now).utc());
  const activeIndex = contracts.findIndex(
    ({ contractStartDate, contractEndDate }) =>
      !!contractStartDate &&
      !!contractEndDate &&
      dayjs(today).isBetween(contractStartDate, contractEndDate, 'day', '[]'),
  );
  return activeIndex === -1 ? contracts.length - 1 : activeIndex;
};
